import React, { useEffect, useState } from 'react';
import { endPoints } from '../../../utils/endpoints';
import { makePatchCall } from '../../../effects/requests';
import { ApiResponseType } from '../../../types';
import { emptyFunction, showToast } from '../../../utils';

interface Props {
    onClose: () => void;
    onDone: () => void;
    locationData?: any
}

const AddTagsPopUp: React.FC<Props> = ({ onClose, onDone, locationData }) => {
    const [tag, setTag] = useState('');
    const [tags, setTags] = useState<string[]>(locationData?.tags?.length > 0 ? locationData?.tags : []);

    const handleAddTag = () => {
        const value = tag.trim();

        if (!value) {
            showToast('Please enter a tag', 'error');
            return;
        }

        if (tags.includes(value)) {
            showToast('Tag already added', 'error');
            return;
        }

        setTags((prev) => [...prev, value]);
        setTag('');
    };

    const handleKeyDown = (
        event: React.KeyboardEvent<HTMLInputElement>
    ) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleAddTag();
        }
    };

    const handleRemove = (index: number) => {
        setTags((prev) =>
            prev.filter((_, i) => i !== index)
        );
    };

    const handleApply = () => {
        // if (tags?.length === 0) {
        //     showToast('Please add at least one tag', 'error');
        //     return;
        // }

        const payload = {
            tags: tags?.length > 0 ? tags : []
        }

        const url = `${endPoints.LOCATION}${locationData?.id}/`
        makePatchCall(url, payload).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message || '', 'success')
                onDone();
            }
        }).catch(emptyFunction);

    };

    useEffect(() => {
        setTags(locationData?.tags?.length > 0 ? locationData?.tags : [])
    }, [locationData?.tags])

    return (
        <div className="lc-modal-overlay">
            <div
                style={{ textAlign: 'left' }}
                className="lc-modal"
            >
                <button
                    type="button"
                    className="lc-modal__close"
                    onClick={onClose}
                >
                    <img
                        src="/assets/images/dismiss.svg"
                        alt="close"
                    />
                </button>

                <div className="lc-modal__icon">
                    <img
                        src="/assets/images/badge-check.svg"
                        alt="location created"
                    />
                </div>

                <h2 className="lc-modal__title">
                    Add tags
                </h2>

                <p
                    style={{ textAlign: 'center' }}
                    className="lc-modal__desc"
                >
                    Press enter after each tag, these are private
                    and help with your search.
                </p>

                {tags.length > 0 && (
                    <div className="lt-tags">
                        {tags.map((item, index) => (
                            <div
                                key={`${item}-${index}`}
                                style={{ position: 'relative' }}
                            >
                                <span className="lt-tag">
                                    {item}
                                </span>

                                <img
                                    src="/assets/images/cross-cercle-fill-red.svg"
                                    alt="Remove tag"
                                    onClick={() =>
                                        handleRemove(index)
                                    }
                                    style={{
                                        position: 'absolute',
                                        right: '-8px',
                                        top: '-10px',
                                        width: '25px',
                                        height: '25px',
                                        cursor: 'pointer',
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}

                <div style={{ width: '100%' }} className="ac-invite-row">
                    <input
                        className="ac-invite-input"
                        type="text"
                        placeholder="Type tag..."
                        value={tag}
                        onChange={(e) => setTag(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />

                    <button
                        type="button"
                        className="ac-invite-btn"
                        onClick={handleAddTag}
                    >
                        <img
                            src="/assets/images/plus-icon.svg"
                            alt="add"
                        />
                        Add
                    </button>
                </div>

                <div className="lc-modal__buttons">
                    <button
                        style={{ width: '200px' }}
                        type="button"
                        className="lc-modal__btn lc-modal__btn--primary"
                        onClick={handleApply}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddTagsPopUp;